module.exports = __webpack_public_path__ + "assets-cabinet/img/sent_read.49af0022.svg";